import axios from 'axios';

const api = {
  // Sensis
  sensisApi: {
    async parseAddress(address) {
      const res = await axios.get(`/sensis-api/address/parse?address=${encodeURIComponent(address)}`);
      return res.data;
    },
    async getAddressDetails(addressId) {
      const res = await axios.get(`/sensis-api/address/detail?addressId=${addressId}`);
      return res.data;
    },
  },
  // Reporting
  reporting: {
    async getDonations(startDate, endDate) {
      const res = await axios.get(`/reporting/donations?startDate=${startDate}&endDate=${endDate}`);
      return res.data;
    },
  },
  // Event Logs
  eventLogs: {
    async getEventLogs(status) {
      const res = await axios.get(`/event-logs/event-logs?status=${status}`);
      return res.data;
    },
    async sync(id) {
      const res = await axios.post(`/event-logs/sync`, { id });
      return res.data;
    },
  },
};

export default api;
